import { __assign } from 'tslib';
import { ICON_MAP } from '../consts/iconMap.js';
import '@alfalab/icons-glyph/CheckmarkCompactMIcon';
import '@alfalab/icons-glyph/CheckmarkCompactSIcon';
import '@alfalab/icons-glyph/ClockHandsCompactMIcon';
import '@alfalab/icons-glyph/ClockHandsCompactSIcon';
import '@alfalab/icons-glyph/CrossCompactMIcon';
import '@alfalab/icons-glyph/CrossCompactSIcon';
import '@alfalab/icons-glyph/ExclamationCompactMIcon';
import '@alfalab/icons-glyph/ExclamationCompactSIcon';
import '@alfalab/icons-glyph/InformationCompactMIcon';
import '@alfalab/icons-glyph/InformationCompactSIcon';
import '@alfalab/icons-glyph/StopBrickCompactMIcon';
import '@alfalab/icons-glyph/StopBrickMIcon';
import '@alfalab/icons-glyph/StopBrickSIcon';

var useStatusBadgeIcon = function (view, size, customIcons) {
    var iconsMap = ICON_MAP;
    // transform initial icons map
    if (customIcons) {
        iconsMap = Object.keys(ICON_MAP).reduce(function (acc, current) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {},
                _a[current] = __assign(__assign({}, ICON_MAP[current]), customIcons[current]),
                _a)));
        }, {});
    }
    var Icon = iconsMap[view][size];
    return { Icon: Icon };
};

export { useStatusBadgeIcon };
